import CtaButtons from './CtaButtons';
import Footer from './Footer';
import FormField from './FormField';
import Header from './Header';
import SectionContent from './SectionContent';
import SectionForm from './SectionForm';
import SectionHero from './SectionHero';
import SectionPosts from './SectionPosts';
import FeaturedPosts from './FeaturedPosts';

import Layout from './Layout';

export {
    CtaButtons,
    Footer,
    FormField,
    Header,
    SectionContent,
    SectionForm,
    SectionHero,
    SectionPosts,
    FeaturedPosts,
    Layout
};

export default {
    CtaButtons,
    Footer,
    FormField,
    Header,
    SectionContent,
    SectionForm,
    SectionHero,
    SectionPosts,
    FeaturedPosts,
    Layout
};
